import { gql } from "@apollo/client";

export const SEARCH_TOFU_WORKSPACES = gql`
  query SearchTofuWorkspaces($input: SearchInput!) {
    searchTofuWorkspaces(input: $input) {
      edges {
        cursor
        node {
          id
          name
          isLocked
          lockedBy
          createdAt
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        endCursor
        startCursor
      }
    }
  }
`;
